import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { InsightApiService } from './insight-api.service';
import { TrackerService } from 'src/app/repository/service/tracker.service';
import { RoleService } from '../../services/role-service/role.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CopyToClipboardDialogComponent } from '../../copy-to-clipboard-dialog/copy-to-clipboard-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class InsightsService {
  public isInsight: boolean = false;
  public isVOC: boolean = false;
  public insightType:string = '';
  public insightName:string = '';
  public visibility:string = 'everyone';
  public uuid:string = '';
  public insightList:any = null;
  public VOCList:any = null;
  public VOCClubList:any = null;
  public VOCsToBeClub:any = null;
  public newInsight:any;
  public vocData:any = "";
  public vocType:string = '';
  public vocScreenPng: any = [];
  public vocIntroFormtitle:string="";
  public vocIntroScreenName:string="";
  public vocIntroFormSubtitle:any=[{value:""}];
  public isvocadd:boolean=true;
  public isvocEdit:boolean=false;
  public isvocdelete:boolean=false;
  public current_file_uuid:any = "";
  public current_voc_uuid:any = "";
  public video_duration;
  public start_time:string = "";
  public end_time:string ="";
  public comment:string="";
  public isvocEditFormSubmit:boolean = false;
  public isVocFileDelete:boolean = false;
  public copiedVOCData = null;
  public copyvocIntroFormSubtitle:any;
  public copyvocIntroFormtitle:string="";
  // public setCommentsOnStudyLevelEvent = new EventEmitter<null>();
  public commentNotifEmailyArr:any = [];
  public commentNotifEmailyArrCopy:any = [];
  public accessRoles:any;
  public canMarkVOC: boolean = false;
  public canMarkClubVOC: boolean = false;
  public isclubVoc:boolean=false;
  public vocStudyLevelArray:any=null;
  public isVocClubEdit:boolean = false;

  public isSafari: boolean = false;
  public videoUrl: string;
  public isVocCompCallFromStudyLevel:boolean = false;
  public icvCommentEventEmitter = new EventEmitter<string>();

  constructor(public iApiService:InsightApiService,
    private router: Router, 
    public notifier: NotifierService,
    public trackerService:TrackerService,
    private roleService: RoleService,
    public copyDialogRef: MatDialog
    ) { 
    this.isInsight = false;
    this.isVOC = false;
    this.insightType = '';
    this.vocType = '';
    this.uuid = '';
  }


  openInsight(uuid,type,name){
    this.isVOC = false;
    this.isInsight = true;
    this.insightType = type;
    this.insightName = name;
    this.visibility = '';
    this.uuid= uuid;
    let body = {"uuid":this.uuid,"type":this.insightType};
    this.getInsightList(body);
  }

  openVOC(uuid,type:string){
    this.isInsight = false;
    this.isVOC = true;
    this.vocType = type;
    this.uuid = uuid;
    if(type === 'study'){
      this.isVocCompCallFromStudyLevel = true;
    }else{
      this.isVocCompCallFromStudyLevel = false;

    }
    // this.trackerService.startTimer();
  }

  close(){
    // if(this.insightType == 'study'){
    //   this.setCommentsOnStudyLevelEvent.emit();
    // }
    // this.submitTacker();
    this.isInsight = false;
    this.isVOC = false;
    this.uuid = '';
    this.insightType = '';
    this.visibility = '';
    this.insightList = null;
    this.isclubVoc = false;
    // this.VOCClubList = null;
    this.VOCsToBeClub = null;
  }

  // submitTacker(){
  //   if (this.isVOC) {
  //     this.trackerService.stopTimer();
  //     let data = {}
  //     data['uuid'] = this.uuid;
  //     data['file_type'] = 'voc';
  //     data['type'] = this.vocType;
  //     data['misc'] = {'type':this.vocType};
  //     data['viewtime'] = this.trackerService.interval;
  //     data['action'] = 'exit';
  //     if (data['uuid'] && data['uuid'] != '') {
  //       this.trackerService.submitTracker(data);
  //       // console.log("data is" , data)
  //     }
  //     this.trackerService.interval = 0;
  //   }
  // }

  checkMarkVOCAccess() {
    // this.accessRoles = this.roleService.getRoles();
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    if(this.accessRoles && this.accessRoles.access_rules && this.accessRoles.access_rules.repository && this.accessRoles.access_rules.repository.voc){
      if(this.accessRoles.access_rules.repository.voc.markvoc){
        this.canMarkVOC = true;
      }
      if(this.accessRoles.access_rules.repository.voc.clubvoc){
        this.canMarkClubVOC = true;
      }
    }
  }

  updateCommentVisibility(body){
    this.iApiService.updateCommentVisibility(body)
    .subscribe(
      result =>{}
    )
  }

  getInsightList(body){
    this.iApiService.getInsightList(body)
    .subscribe(
      result =>{
        if (result['status'] == 1) {
          this.insightList = result['insights'].length>0 ? result['insights'] : [];
          this.visibility = this.insightList.length>0 ? 'everyone' : '';
          this.commentNotifEmailyArr = result['users'].length>0 ? result['users'] : [];
          if(this.commentNotifEmailyArr.length > 0)
          {
            let arr = [];
            let copyarr = []
            for(let Item of this.commentNotifEmailyArr)
            {
              arr.push({value:Item,checked:true});
              copyarr.push({value:Item,checked:true});

            }
            this.commentNotifEmailyArr = arr;
            this.commentNotifEmailyArrCopy = copyarr;

          }
          this.insightList.map((obj,i) =>{
            obj['background'] = this.random_rgba();
            obj['shortname'] = obj['name'].charAt(0);
            let lastname = obj['name'].split(" ").length > 1 ? obj['name'].split(" ")[1].charAt(0):'';
            obj['shortname'] += lastname;
            obj['shortname'] = obj['shortname'].toUpperCase();
          })
          this.icvCommentEventEmitter.emit();
        }
        
      }
    )
  }


  addInsight(body){
    this.iApiService.addInsight(body)
    .subscribe(result =>{
      if (result['status'] == 1) {
        this.notifier.notify('success','Comment Added successfully');
        this.getInsightList({"uuid":this.uuid,"type":this.insightType});
      }
      else
      {
        this.notifier.notify('error','Something Went Wrong');
      }
    })
    
  }

  // copyVocURL(index){
  copyVocURL(obj){
    // this.iApiService.copyVocURL({"uuid":this.VOCList[index].uuid})
    this.iApiService.copyVocURL(obj)
    .subscribe(result =>{
      if (result['status'] == 1) {
        if(navigator.userAgent.indexOf("Safari") > -1 
        &&  !(navigator.userAgent.indexOf("Chrome") > -1)){
          this.isSafari = true;
        }
        this.videoUrl = window.location.origin;
        this.videoUrl+= '/video/'+result['response'];
        if(!this.isSafari) {
          this.notifier.notify('success','Link copied successfully');
          let textarea = document.createElement('textarea');
          textarea.setAttribute('type', 'hidden');
          textarea.textContent = this.videoUrl;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          textarea.remove();
        } else {
            this.openCopyUrlDialog()
        }
      }
    });
  }
  // copyVocURLFromStudy = (ind1,ind2) =>
  // {
  //   this.iApiService.copyVocURL({"uuid":this.vocStudyLevelArray[ind2]['vocs'][ind1].uuid})
  //   .subscribe(result =>{
  //     if (result['status'] == 1) {
  //       let video_id = result['response'];
  //       this.notifier.notify('success','Link copied successfully');
  //       this.createExternalVocRouterURL(this.vocStudyLevelArray[ind2]['vocs'][ind1].uuid,video_id);
  //     }
  //   });
  // }

  // copyClubVocURL(index) {
  //   this.iApiService.copyVocURL({"clubbed_voc_uuid":this.VOCClubList[index].uuid})
  //   .subscribe(result =>{
  //     if (result['status'] == 1) {
  //       let video_id = result['response'];
  //       this.notifier.notify('success','Link copied successfully');
  //       this.createExternalVocRouterURL('',video_id);
  //     }
  //   });
  // }

  openCopyUrlDialog() {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.width = '350px',
    dialogConfig.data = {
        videoFullUrl: this.videoUrl
    };
    this.copyDialogRef.open(CopyToClipboardDialogComponent, dialogConfig)
  }

  // createExternalVocRouterURL(uuid,video_id){
  //   let url = window.location.origin;
  //   url+= '/video/'+video_id; 

  //   let textarea = document.createElement('textarea');
  //   textarea.setAttribute('type', 'hidden');
  //   textarea.textContent = url
  //   document.body.appendChild(textarea);
  //   textarea.select();
  //   document.execCommand('copy');
  //   textarea.remove();

  // }

  random_rgba() {
    var o = Math.round, r = Math.random, s = 255;
    return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + 0.6 + ')';
  }

  getSubStr(str,length){
    if (str && str.length > length) {
      return str.substr(0,length) + '...'
    }else{
      return str;
    }
  }

  showMatTooltip(str,length){
    if(str && str.length > length) return str;
    return '';
  }

  // addClubVoc(data) {
  //   this.iApiService.addClubVoc(data).subscribe((result) => {
  //     if(result['status'] == '1'){
  //       console.log('VOCs clubbed result',result);
  //       this.notifier.notify('success','VOCs Clubbed successfully');
  //       if(this.vocType == 'study') {
  //         this.isVocClubEdit = false;
  //         this.VOCsToBeClub = null;
  //         this.isclubVoc = false;
  //       }
  //       else{

  //       }
  //     }
  //     else{
  //       this.notifier.notify('error','Something went wrong VOCs could not be clubbed');
  //     }
  //   })
  // }

  // getVocClubs(uuid) {
  //   this.iApiService.getVocClubs(uuid).subscribe((result) => {
  //     if(result['status'] == 1){
  //       console.log('clubbed VOCs',result);
  //     }
  //     else{
  //       console.log('Error in getting clubbed VOCs');
  //     }
  //   })
  // }

  createScreen() {
    let obj = {};
    obj['background'] = this.screenVocColors();
    obj['isHovered'] = false;
    obj['media_type'] = 'audio';
    obj['type'] = 'screen';
    obj['preview'] = {};
    obj['preview']['title'] = this.vocIntroFormtitle;
    if(this.vocIntroFormSubtitle[0].value != '') {
      obj['preview']['text'] = [];
      this.vocIntroFormSubtitle.forEach((val) => {
        obj['preview']['text'].push(val.value);
      })
    }
    this.VOCsToBeClub.vocs.push(obj);
    this.copyvocIntroFormSubtitle = undefined;
    this.copyvocIntroFormtitle="";
    this.vocIntroFormtitle="";
    this.vocIntroFormSubtitle=[{value:""}];
  }

  screenVocColors = () =>{
    const colors = ['#6C5CE7','#0984E3','#FF7675','#40CDAE']
    let count = 0;
    this.VOCsToBeClub.vocs.forEach((ele) => {
      let ownKey = ele.hasOwnProperty('vcm_type') ? 'vcm_type' : 'type';
      if(ele[ownKey] == 'screen') {
        count = count + 1;
      }
    })

    if(count < 4) {
      return colors[count];
    } else {
      let ind = count % 4;
      return colors[ind];
    }
  }


}
